/* global $, _, Backbone */

var DELAY_SHOW = 500
var DELAY_HIDE = 0

export const MegaMenuView = Backbone.View.extend({
  initialize: function (options) {
    this.mouseInside = options.mouseInside

    this.$mega = $(options.mega)

    this.$el.on('mouseover', _.bind(this.onHoverHandler, this))

    $('body').on('mouseover', _.bind(this.onCancelShow, this))
    $('body').on('mouseover', _.bind(this.onHide, this))
    $('body').on('mouseover', _.bind(this.onCancelHide, this))
  },

  onHoverHandler: function(e) {
    var onShow = _.bind(this.onShow, this)
    this.$element = $(e.currentTarget)
    onShow()
  },

  onShow: function () {
    var showMega = _.bind(this.showMega, this)

    window.clearTimeout(this.showTimeout)
    this.$mega.hide()
    this.$element.find(this.$mega).show()
    this.showTimeout = window.setTimeout(showMega, DELAY_SHOW)
  },

  onCancelShow: function (evt) {
    if (this.visible) {
      return
    }

    if ($(evt.target).closest(this.$el).length) {
      return
    }

    window.clearTimeout(this.showTimeout)
  },

  onHide: function () {
    var hideMega = _.bind(this.hideMega, this)

    window.clearTimeout(this.hideTimeout)
    this.hideTimeout = window.setTimeout(hideMega, DELAY_HIDE)
  },

  onCancelHide: function (evt) {
    var isMega = $(evt.target).closest(this.$mega).length > 0
    var isMenu = $(evt.target).closest(this.$el).length > 0

    if (isMega || isMenu || this.mouseInside(evt.target)) {
      window.clearTimeout(this.hideTimeout)
    }
  },

  showMega: function () {
    if (this.visible && !this.$element) {
      return
    }

    window.clearTimeout(this.hideTimeout)
    this.$el.removeClass('open')
    this.$element.addClass('open')
    this.visible = true
  },

  hideMega: function () {
    if (!this.visible) {
      return
    }

    window.clearTimeout(this.showTimeout)
    this.$el.removeClass('open')
    this.$mega.hide()
    this.visible = false
  },
})


// WEBPACK FOOTER //
// ./Private/Scripts/modules/megaMenu.js